import { render, staticRenderFns } from "./AssetsForm.vue?vue&type=template&id=500afc75"
import script from "./AssetsForm.js?vue&type=script&lang=js&external"
export * from "./AssetsForm.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports